export default __webpack_public_path__ + "static/media/darkIcon.ba6fbe4d.png";